import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["requiredCheckbox", "submit"]

  connect() {
    this.toggleSubmit()
  }

  toggleSubmit() {
    if (!this.hasSubmitTarget) return

    this.submitTarget.disabled = !this.requiredCheckboxTargets.every((checkbox) => checkbox.checked)
  }
}